import { CHOICES, RESULT_CONFIG } from "../../utils/constants";
import WaitingDots from "./WaitingDots";

const ResultPanel = ({ result, myChoice, oppChoice, isHost, onNextRound }) => {
  const config = RESULT_CONFIG[result];

  return (
    <div className="result-panel">
      <span className="result-emoji">{config.emoji}</span>

      <div className={`result-text result-${result}`}>
        {config.text}
      </div>

      <div className="result-detail">
        {CHOICES[myChoice]?.emoji} {CHOICES[myChoice]?.label}
        {" "} vs {" "}
        {CHOICES[oppChoice]?.emoji} {CHOICES[oppChoice]?.label}
      </div>

      {isHost ? (
        // Host (p1) controls round advancement
        <button className="btn btn-primary" onClick={onNextRound}>
          Next Round →
        </button>
      ) : (
        // Guest (p2) waits for host
        <div className="opp-waiting-msg">
          <WaitingDots /> Waiting for host to continue...
        </div>
      )}
    </div>
  );
};

export default ResultPanel;